import React from 'react';
import { PropTypes } from 'prop-types';

const HelpContact = ({ className, t, contactPhone, contactMail }) => (
  <div className={className}>
    <div>
      <span className="label">{t('phone')}</span>
      <span className="payload">{contactPhone}</span>
    </div>

    <div>
      <span className="label">{t('email')}</span>
      <span className="payload">{contactMail}</span>
    </div>
  </div>
);

HelpContact.propTypes = {
  className: PropTypes.string,
  contactPhone: PropTypes.string,
  contactMail: PropTypes.string,
  t: PropTypes.func,
};

HelpContact.defaultProps = {
  className: '',
  contactPhone: '',
  contactMail: '',
  t: (t) => t,
};

export default HelpContact;
